import Icon from '../components/Icon.vue'

Icon.register({
  'map-pin': {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M112 316.9c10.4 1.9 21.1 3.1 32 3.1s21.6-1.1 32-3.1v156.7l-22 33c-4.8 7.1-15.2 7.1-20 0l-22-33v-156.7zM144 0c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144zM144 76c6.6 0 12-5.4 12-12s-5.4-12-12-12c-50.7 0-92 41.3-92 92 0 6.6 5.4 12 12 12s12-5.4 12-12c0-37.5 30.5-68 68-68z'
      }
    ]
  }
})
